import { Message } from 'element-ui'
import cache from './cache'

const install = function (Vue) {
  Vue.axios.defaults.timeout = 10000
  // 网络请求 全局拦截
  Vue.axios.interceptors.request.use(function (request) {
    // 发送请求之前，判断是否需要添加access_token
    if (!request.params) {
      request.params = {}
    }
    if (request.params && !request.params.open) {
      let user = cache.getSession('dtit_user')
      if (user) {
        // POST放到Body中，Get放在params中
        if (request.params.channel === 1) {
          request.params['token'] = window.vm.$store.state.otherToekn['token']
          // 大工平台lora 空调
        }if(request.data && request.data.data && request.data.data.channel === 2) {
          request.params['access_token'] = 'd9c652af203ff81e4b55fdd2ab5658bd9eea6df5'
        }
        else {
          request.params['access_token'] = user.access_token
        }
      } else {
        // 失败跳转到登录页
        window.vm.$nextTick(() => {
          Message.warning('登录过期，请重新登录')
          window.vm.$router.replace({ name: 'login' })
        })
      }
    }
    if (request.params && request.params.open) {
      delete request.params.open
    }
    return request
  }, function (error) {
    // Do something with request error
    return Promise.reject(error)
  })

  Vue.axios.interceptors.response.use(function (response) {
    // Do something with response data
    if ((response.data.code >= 10000 && response.data.code < 20000) || (response.data.code === 5 && response.data.msg === 'ERR_NOT_FOUND_USR')) {
      // Access_Token存在问题，直接回登录页，重新认证
      cache.removeSession('dtit_user')
      cache.removeCache('user_info')
      // 跳转路由
      window.vm.$nextTick(() => {
        Message.warning('登录过期，请重新登录')
        window.vm.$router.replace({ name: 'login' })
      })
      return
    }
    if (response.statusText !== 'OK' && response.status !== 200) {
      return Promise.reject(new Error('网络请求超时，请检查网络'))
    }
    return response
  }, function (error) {
    console.log('request error')
    // Do something with response error
    return Promise.reject(error)
  })

  Vue.axios.jsonp = (url) => {
    if (!url) {
      throw new Error('Axios.JSONP 至少需要一个url参数!')
    }
    return new Promise((resolve, reject) => {
      window.jsonCallBack = (result) => {
        resolve(result)
      }
      const JSONP = document.createElement('script')
      JSONP.type = 'text/javascript'
      JSONP.src = `${url}&callback=jsonCallBack`
      Vue._logger.debugger(JSONP.src)
      document.getElementsByTagName('head')[0].appendChild(JSONP)
      setTimeout(() => {
        document.getElementsByTagName('head')[0].removeChild(JSONP)
      }, 500)
    })
  }
}

export default install
